module.exports = __webpack_public_path__ + "img/camp05_actived.5f240721.png";